import { Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApiError } from "../../../../common/errors/useApiError";
import { TipTap } from "../../../../common/input/TipTap/TipTap";
import { useSaveOrganization } from "../useOrganizationEditor";

interface Props {
  currentValue: string;
}

export const ChangeAboutUs = ({ currentValue }: Props) => {
  const { saveOrganization } = useSaveOrganization();
  const { t } = useTranslation();
  const displayer = useApiError();
  const [initialContent] = useState<string>(currentValue);

  const save = async (value: string) => {
    try {
      await saveOrganization({ aboutUs: { value } });
    } catch (e) {
      displayer.trigger(e);
      throw e;
    }
  };

  return (
    <>
      <Text fontWeight="medium" pt="5">
        {t("About us")}
      </Text>
      <TipTap ariaLabel={t("About us") ?? ""} content={initialContent} onUpdate={save} />
    </>
  );
};
